"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMembershipTemplates = exports.fetchStylesheets = exports.fetchBlogTemplates = exports.fetchSystemTemplates = exports.fetchSubscriptionTemplates = void 0;

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _API = _interopRequireDefault(require("./API"));

var fetchSubscriptionTemplates = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getSubscriptionTemplates,
  initiatingActionType: _actions.DesignTemplatesActionTypes.LOAD_SUBSCRIPTION_TEMPLATES,
  requestStatusSelector: _selectors.getFetchSubscriptionTemplatesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchSubscriptionTemplates
}));
exports.fetchSubscriptionTemplates = fetchSubscriptionTemplates;
var fetchSystemTemplates = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getSystemTemplates,
  initiatingActionType: _actions.DesignTemplatesActionTypes.LOAD_SYSTEM_TEMPLATES,
  requestStatusSelector: _selectors.getFetchSystemTemplatesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchSystemTemplates
}));
exports.fetchSystemTemplates = fetchSystemTemplates;
var fetchBlogTemplates = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getBlogTemplates,
  initiatingActionType: _actions.DesignTemplatesActionTypes.LOAD_BLOG_TEMPLATES,
  requestStatusSelector: _selectors.getFetchBlogTemplatesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchBlogTemplates
}));
exports.fetchBlogTemplates = fetchBlogTemplates;
var fetchStylesheets = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getStylesheets,
  initiatingActionType: _actions.DesignTemplatesActionTypes.LOAD_STYLESHEETS,
  requestStatusSelector: _selectors.getFetchStylesheetsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchStylesheets
}));
exports.fetchStylesheets = fetchStylesheets;
var fetchMembershipTemplates = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getMembershipTemplates,
  initiatingActionType: _actions.DesignTemplatesActionTypes.LOAD_MEMBERSHIP_TEMPLATES,
  requestStatusSelector: _selectors.getFetchMembershipTemplatesRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchMembershipTemplates
}));
exports.fetchMembershipTemplates = fetchMembershipTemplates;